import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { MailDraftItem } from '../../../external/MailDraftApi';
import { actions } from '../../modules/Actions';

export interface MailDraftState {
  mailDraftInfo: MailDraftItem | null
}

export const initialState: MailDraftState = {
  mailDraftInfo: null,
};

export const MailDraftReducer = reducerWithInitialState(initialState).case(
  actions.fetchMailDraft,
  (state: MailDraftState, payload: MailDraftState) => {
    return payload;
  }
);
